var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import { Dropdown } from "react-bootstrap";
import { Calendar } from "react-date-range";
import PropTypes from "prop-types";
import moment from "moment";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import "./FormDate.scss";

var FromDate = function FromDate(_ref) {
  var selectText = _ref.selectText,
      size = _ref.size,
      date = _ref.date,
      dateDisplayFormat = _ref.dateDisplayFormat,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, ["selectText", "size", "date", "dateDisplayFormat", "disabled"]);

  return React.createElement(
    Dropdown,
    { className: "form-date" },
    React.createElement(
      Dropdown.Toggle,
      {
        size: size,
        id: "dropdown-form-date",
        className: "font-weight-light w-100 form-control " + (date ? "" : "placeholder") + " " + (size ? "form-control-" + size : ""),
        disabled: disabled
      },
      date ? moment(date).format(dateDisplayFormat) : selectText
    ),
    React.createElement(
      Dropdown.Menu,
      null,
      React.createElement(Calendar, date ? _extends({ date: date }, rest) : rest)
    )
  );
};

FromDate.defaultProps = {
  color: "#004b78",
  selectText: "Date",
  direction: "vertical",
  showMonthAndYearPickers: true,
  showSelectionPreview: true,
  months: 1,
  disabledDates: [],
  dateDisplayFormat: "MMM DD, yyyy",
  date: new Date()
};
FromDate.propTypes = process.env.NODE_ENV !== "production" ? {
  /*
   *Selection dropdown text
   */
  selectText: PropTypes.string,
  //selection dropdown size
  size: PropTypes.oneOf(["sm", "default"]), //selection dropdown size
  disabled: PropTypes.bool, //disable/enable

  color: PropTypes.string,
  locale: PropTypes.object, //default en-us. refer https://www.npmjs.com/package/react-date-range
  className: PropTypes.string, //wrapper classname
  months: PropTypes.number, //rendered month count
  showSelectionPreview: PropTypes.bool, //show preview on focused/hovered dates
  showMonthAndYearPickers: PropTypes.bool, //show select tags for month and year on calendar top, if false it will just display the month and year
  rangeColors: PropTypes.array, //defines color for selection preview.
  shownDate: PropTypes.instanceOf(Date), //initial focus date
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  direction: PropTypes.oneOf(["vertical", "horizontal"]),
  disabledDates: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  date: PropTypes.instanceOf(Date), //date value for Calendar
  onChange: PropTypes.func.isRequired //callback function for date changes. fn(date: Date)
} : {};
export default FromDate;